//const domain = process.env.NODE_ENV === "development" ? "raydevelop.com" : "rayteams.com";
//const domain = "raydevelop.com";
const domain = location.href.indexOf(".rayteams.com") > -1 ? "rayteams.com" : "raydevelop.com";
export const API = {
	Login : "https://api-ap-northeast-2-user." + domain + "/login",
	UserUpdatePassword : "https://api-ap-northeast-2-user." + domain + "/requrestpasswordemail",
	UserUpdateInfo : "https://api-ap-northeast-2-user." + domain + "/",
}
